import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "list__item" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "list__border" }, null, -1)
const _hoisted_5 = {
  key: 3,
  class: "list__russian-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.words?.enValues == null)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          ref: el => _ctx.enItemsInfo[0] = el,
          class: "list__english"
        }, _toDisplayString(_ctx.words.english), 513))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.words.enValues, (item, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "list__english",
              key: item,
              ref_for: true,
              ref: el => { if (el) _ctx.enItemsInfo[index] = el }
            }, [
              _createTextVNode(_toDisplayString(item) + " ", 1),
              (index != _ctx.words.enValues.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, ", "))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])),
    _hoisted_4,
    (_ctx.words?.ruValues == null)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "list__russian",
          ref: el => _ctx.itemsInfo[0] = el
        }, _toDisplayString(_ctx.words.russian), 513))
      : (_openBlock(), _createElementBlock("span", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.words.ruValues, (item, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "list__russian",
              key: item,
              ref_for: true,
              ref: el => { if (el) _ctx.itemsInfo[index] = el }
            }, _toDisplayString(item), 1))
          }), 128))
        ]))
  ]))
}